import { getUserNameFromToken } from "../auth/SecurityManager";

export const useUserData = () => {
    const userName = getUserNameFromToken();

    return [userName];
};
